import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfWheelZoomModule } from '@app/shared/directives/pdf-wheel-zoom.module';
import { SupportComponent } from './support.component';

@NgModule({
  declarations: [SupportComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    MatButtonModule,
    NgxExtendedPdfViewerModule,
    PdfWheelZoomModule,
  ],
})
export class SupportModule {}
